import { render } from "./BillResto.vue?vue&type=template&id=0dda18c9&scoped=true"
import script from "./BillResto.vue?vue&type=script&lang=js"
export * from "./BillResto.vue?vue&type=script&lang=js"

import "./BillResto.vue?vue&type=style&index=0&id=0dda18c9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dda18c9"]])

export default __exports__